<template>
    <div class="container">
        <div class="card mb-4">
            <div class="card-body">
                <div class="card-body p-2 text-center">
                    <small>
                        招待するにはこのQRコード<br>を読み取ってもらってください
                    </small>
                </div>
                <div class="card-body p-0 text-center">
                    <qrcode v-if="role == '1'" :value="getInviteInfo.invite_url" :options="{width:200, color:{dark:'#f3231d'}}"></qrcode>
                    <qrcode v-if="role == '0'" :value="getInviteInfo.invite_url" :options="{width:200, color:{dark:'#3490dc'}}"></qrcode>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            role: String
        },
        computed: {
            ...mapGetters(['getInviteInfo'])
        }
    }
</script>

<style lang="stylus" scoped>
</style>
